import Vue, { inject } from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'
import createPersistedState from 'vuex-persistedstate'
import { addressInput } from './addressInput.module'

const BROWSERS = {
    chrome: 'chrome',
    firefox: 'firefox',
    opera: 'opera',
    safari: 'safari',
    internetExplorer: 'IE',
    edge: 'edge',
    edgeChromium: 'edgeChromium',
    blinkEngine: 'blink',
    unknown: 'unknown',
}

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        status: '',
        loading: false,
        isLogistic: false,
        isSettings: false,
        isGeofence: false,
        isAnalytic: false,
        settingsLock: true,
        isAnalyticFilterPopup:false,
        isOrderWindowClose: true,
        isServiceWindowClose: true,
        width: 450,
        freeCouriers: [],
        orderSend: [],
        secu9: '',
        token: '',
        user: {},
        settings: {},
        geofences: '',
        needSave: '',
        operator_tid: 0,
        userIsPoint: false,
        userIsService: false,
        userIsOperator: false,
        freeCouriersCount: null, 
        showMarkers: { // выполненные заказы, заказы, точки, курьеры, стрелки
            ordersComplete: false,
            servicesComplete: false,
            orders: true,
            services: true,
            points: true,
            couriers: true,
            workers:true,
            arrows: true,
        },
        BROWSERS: BROWSERS,
        operationSystem: '',
        browser: '',
    },
    plugins: [createPersistedState()],
    mutations: {
        window_width: (state, data) => (state.width = data),
        needSave: (state, data) => (state.needSave = data),
        geofences: (state, data) => (state.geofences = data),
        showMarkers: (state, data) => (state.showMarkers = data),
        auth_request(state) {
            console.log('state auth_request')
            state.status = 'loading'
        },
        secu_init(state, data) {
            // секу нужен для того чтобы все аккаунты без поля секу автоматически вышли и потребовали вход через новый пароль
            console.log('state secu_init')
            state.secu9 = 'secu9'
        },
        auth_success(state, data) {
            // console.log('state auth_success', data.token, data.user)
            state.status = 'success'

            state.token = data.token
            state.user = data.user
            state.settings = data.user.settings
            // console.log('data.user', data.user)
            // console.log('data.user.settings', data.user.settings)
            // console.log('state.settings', state.settings)

            if (!state.settings.tz) {
                state.settings.tz = config.tz
            }
            // console.log('tz from store', state.settings.tz)
            axios.defaults.headers.common['tz'] = state.settings.tz

            if (!state.settings.tz_string) {
                state.settings.tz_string = config.tz_string
            }
            // console.log('tz_string from store', state.settings.tz_string)
            axios.defaults.headers.common['tz_string'] = state.settings.tz_string

            if (!state.settings.city) {
                state.settings.city = config.city
            }
            // console.log('city from store', state.settings.city)
            // axios.defaults.headers.common['city'] = state.settings.city

            state.userIsOperator = state.user.role === config.user.role.operator
            state.userIsPoint = state.user.role !== config.user.role.operator
            state.userIsService = state.user.role === config.user.role.service
            if (state.userIsPoint||state.userIsService) {
                state.operator_tid = state.user.operator_tid
            } else {
                state.operator_tid = state.user.tid
            }
        },
        auth_error(state) {
            console.log('state auth_error')
            state.status = 'error'
        },
        logout(state) {
            console.log('state logout')
            state.status = ''
            state.token = ''
            state.user = ''
            state.settings = ''
            state.userIsPoint= false
            state.userIsService= false
            state.userIsOperator= false
            state.isLogistic= false
            state.isSettings= false
            state.isGeofence= false
            state.isAnalytic= false
            state.settingsLock= true
            state.isAnalyticFilterPopup=false
            state.isOrderWindowClose= true
            state.isServiceWindowClose= true
            state.operator_tid = ''
        },
        settings(state, data) {
            //console.log('state settings', data)
            state.settings = data
        },
    },
    modules: {
        addressInput,
    },
    actions: {
        open_route({ commit }, data) {
            return new Promise((resolve, reject) => {

                if (data.order.latitude && data.order.longitude) {
                    setTimeout(() => {
                        window.open(
                            `https://router.darall.pro?loc=${data.point.latitude},${data.point.longitude}&loc=${data.order.latitude},${data.order.longitude}`,
                            'Darall Router'
                        )
                    })
                } else {
                    Vue.prototype.$notify({
                        text: 'Невозможно построить маршрут, так как место доставки не определено',
                        type: 'error',
                        duration: 4000
                    })
                }

                return resolve()
            })
        },
        async open_multi_route({ commit }, order) {
            let startCoords = ''
            let clientCoords = ''

            if (order && order.orders.every(e => e.coordinates) && Array.isArray(order.orders)) {
                const { orders, pointSequence } = order
                clientCoords = JSON.parse(order.orders[0].coordinates)

                for (let i = 0; i < pointSequence.length; i += 1) {
                    const pointId = pointSequence[i]

                    const foundedOrder = orders.find(e => e.pointIdUuid === pointId)

                    if (typeof foundedOrder !== 'undefined') {
                        await this.dispatch('/v1/point_get', foundedOrder.point_id).then(res => {
                            if (res.data.success && res.data.point.coordinates) {
                                const coord = JSON.parse(res.data.point.coordinates)
                                startCoords += `loc=${coord[1]},${coord[0]}&`
                            }
                        })
                    }
                }
            }

            return new Promise((resolve, reject) => {
                const notifyError = (text) => {
                    Vue.prototype.$notify({
                        text,
                        type: 'error',
                        duration: 4000
                    })
                }

                if (clientCoords.length !== 0 && startCoords.length !== 0) {
                    const routerUrl = `https://router.darall.pro?${startCoords}loc=${clientCoords[1]},${clientCoords[0]}`

                    setTimeout(() => {
                        window.open(routerUrl, 'Darall Router')
                    })


                } else {
                    console.log('ope multi route fail')
                    notifyError('Не удалось построить маршрут')
                }
            })
        },
        broadcasts_get({ commit }, tags) {
            return new Promise((resolve, reject) => {
                const params = {
                    operator_tid: this.state.operator_tid,
                    tags,
                }
                axios
                    .get('/v1/broadcasts', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.error('get broadcasts err', err.stack)
                        reject(err)
                    })
            })
        },
        broadcast_set({ commit }, broadcast) {
            broadcast.operator_tid = this.state.operator_tid
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/broadcast', broadcast)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.error('post broadcast err', err.stack)
                        reject(err)
                    })
            })
        },
        broadcast_delete({ commit }, id) {
            return new Promise((resolve, reject) => {
                const data = {
                    id
                }
                axios
                    .delete('/v1/broadcast', { data })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.error('delete broadcast err', err.stack)
                        reject(err)
                    })
            })
        },
        address_coordinates({ commit }, address) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/address/coordinates', {
                        cityId: this.state.user.city.id,
                        address,
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('address coordinates err', err.stack)
                        reject(err)
                    })
            })
        },
        geofences_get({ commit }) {
            return new Promise((resolve, reject) => {
                const params = {
                    tid: this.state.operator_tid,
                }
                axios
                    .get('/v1/geofences', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('geofences_get err', err.stack)
                        reject(err)
                    })
            })
        },
        geofences_set({ commit }, geofences) {
            return new Promise((resolve, reject) => {
                const params = {
                    data: JSON.stringify(geofences),
                    tid: this.state.user.tid,
                }
                axios
                    .post('/v1/geofences', params)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('geofences_set err', err.stack)
                        reject(err)
                    })
            })
        },
        settings_get({ commit }) {
            return new Promise((resolve, reject) => {
                const params = {
                    login: this.state.user.name,
                }
                axios
                    .get('/v1/user_settings', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('settings_get err', err.stack)
                        reject(err)
                    })
            })
        },
        settings_set({ commit }, settings) {
            return new Promise((resolve, reject) => {
                const params = {
                    login: this.state.user.name,
                    settings,
                }
                axios
                    .post('/v1/user_settings', params)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('settings_set err', err.stack)
                        reject(err)
                    })
            })
        },
        settings_set_id({ commit }, settings){
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/user_settings_id', settings)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('settings_set err', err.stack)
                        reject(err)
                    })
            })
        },
        guest_set({ commit }, guest) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/guest', guest)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('guest_set err', err.stack)
                        reject(err)
                    })
            })
        },
        point_set({ commit }, point) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/point', point)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('point_set err', err.stack)
                        reject(err)
                    })
            })
        },
        user_operator_get({ commit }) {
            const params = {
                tid: this.state.operator_tid,
            }
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/user_operator_tid', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('user_operator_get err', err.stack)
                        reject(err)
                    })
            })
        },
        guests_rate_get({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/guests_rate', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('guests_rate_get err', err.stack)
                        reject(err)
                    })
            })
        },
        call_parsing({commit},params){
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/call_parsing', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('reviews_parsing', err.stack)
                        reject(err)
                    })
            })
        },
        user_get({ commit }, tid) {
            const params = {
                tid,
            }
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/user', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('user_get err', err.stack)
                        reject(err)
                    })
            })
        },
        user_set({ commit }, user) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/user', user)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('user_set err', err.stack)
                        reject(err)
                    })
            })
        },
        user_delete({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/v1/user', { data: { id } })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('user_delete err', err.stack)
                        reject(err)
                    })
            })
        },
        courier_delete_notify({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/courier_delete_notify', { data })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('courier_delete_notify err', err.stack)
                        reject(err)
                    })
            })
        },
        courier_status_notify({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/courier_status_notify', { data })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        courier_disconnect({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/courier_disconnect', {
                        courierId: data.courierId,
                        newOrderStatus: data.newOrderStatus,
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        worker_status_notify({ commit }, data){
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/worker_status_notify', { data })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        users_get({ commit }) {
            return new Promise((resolve, reject) => {
                const params = {
                    operator_tid: this.state.operator_tid,
                }
                axios
                    .get('/v1/operator_users', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('users_get err', err.stack)
                        reject(err)
                    })
            })
        },
        account_set({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/darall_account', { ...data })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('account_set err', err.stack)
                        reject(err)
                    })
            })
        },
        users_set({ commit }, users) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/users', { users })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('users_set err', err.stack)
                        reject(err)
                    })
            })
        },
        review_set({ commit }, review) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/review', review)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('review_set err', err.stack)
                        reject(err)
                    })
            })
        },
        
        order_set({ commit }, order) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/order', order)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order_set err', err.stack)
                        reject(err)
                    })
            })
        },
        multi_order_set({ commit }, order) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/multi_order', order)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order_set err', err.stack)
                        reject(err)
                    })
            })
        },
        send_multi_order({ commit }, order) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/send_multi_order', order)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order_set err', err.stack)
                        reject(err)
                    })
            })
        },
        multi_order_delete({ commit }, orderId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/multi_order_delete', { orderId })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('multi_order_delete err', err.stack)
                        reject(err)
                    })
            })
        },
        service_passed_notify({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/service_passed_notify', {
                        name: data.order.name,
                        operator_tid: this.state.operator_tid,
                        worker_tid: data.order.worker_tid,
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        service_cancel_notify({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/service_cancel_notify', {
                        name: data.order.name,
                        point_id: data.order.point_id,
                        point_tid: data.order.point_tid,
                        status_order: data.order.status,
                        worker_tid: data.order.worker_tid,
                        user: data.user,
                        role: data.userRole,
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        order_restore({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/restore', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order_restore err', err.stack)
                        reject(err)
                    })
            })
        },
        restore_multi_order({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch('/v1/restore_multi_order', {
                        orderId: data.orderId,
                        status: data.status,
                        notify: data.notify,
                        user: data.user,
                        role: data.role,
                        service: data.service
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('restore_multi_order err', err.stack)
                        reject(err)
                    })
            })
        },
        courier_orders_status({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/courier_orders_status', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('courier_orders_status err', err.stack)
                        reject(err)
                    })
            })
        },
        service_set({ commit }, service) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/service', service)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('service_set err', err.stack)
                        reject(err)
                    })
            })
        },
        service_get({ commit }, id) {
            return new Promise((resolve, reject) => {
                const params = {id:id}
                axios
                    .get('/v1/service', {params})
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('service_get err', err.stack)
                        reject(err)
                    })
            })
        },
        service_specs({commit}){
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/service_specs')
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('service specs err', err.stack)
                        reject(err)
                    })
            })
        },
        couriers_salary({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    operator_tid: this.state.operator_tid,
                    date1: data.date1,
                    date2: data.date2,
                    deliveryTime: true,
                }
                axios
                    .get('/v1/couriers_salary', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('couriers_salary err', err.stack)
                        reject(err)
                    })
            })
        },
        sms_send({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    point_id: data.point_id,
                    phone: data.phone,
                    text: data.text,
                }
                axios
                    .get('/v1/sms_send', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('sms_send err', err.stack)
                        reject(err)
                    })
            })
        },
        sms_status({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    point_id: data.point_id,
                    message_id: data.message_id,
                }
                axios
                    .get('/v1/sms_status', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('sms_status err', err.stack)
                        reject(err)
                    })
            })
        },
        sms_balance({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    point_id: data.point_id,
                }
                axios
                    .get('/v1/sms_balance', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('sms_balance err', err.stack)
                        reject(err)
                    })
            })
        },
        sms_limit({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    point_id: data.point_id,
                }
                axios
                    .get('/v1/sms_limit', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('sms_limit err', err.stack)
                        reject(err)
                    })
            })
        },
        sms_check({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    point_id: data.point_id,
                    api_id: data.api_id,
                }
                axios
                    .get('/v1/sms_check', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('sms_check err', err.stack)
                        reject(err)
                    })
            })
        },
        orders_fee_calculate({ commit }, data) {
            return new Promise((resolve, reject) => {
                data.operator_tid = this.state.operator_tid
                data.city = this.state.settings.city
                axios
                    .post('/v1/orders_fee_calculate', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('orders_fee_calculate err', err.stack)
                        reject(err)
                    })
            })
        },

        order_price({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/price', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order price err', err.stack)
                        reject(err)
                    })
            })
        },

        order_list({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/list', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err get orders', err.stack)
                        reject(err)
                    })
            })
        },

        point_list({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/point/list', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err get points', err.stack)
                        reject(err)
                    })
            })
        },

        user_update({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/user/update', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err update user', err.stack)
                        reject(err)
                    })
            })
        },

        user_update_telegram({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/user/update-telegram', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err update user', err.stack)
                        reject(err)
                    })
            })
        },

        point_update({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/point/update', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err update point', err.stack)
                        reject(err)
                    })
            })
        },

        point_auth({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/point/auth', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err auth point', err.stack)
                        reject(err)
                    })
            })
        },

        courier_list({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/courier/list', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err get couriers', err.stack)
                        reject(err)
                    })
            })
        },

        courier_assign_max({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/courier/assign-max', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err courier_assign_max', err.stack)
                        reject(err)
                    })
            })
        },

        point_create_auto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/point/create-auto', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err auto create point', err.stack)
                        reject(err)
                    })
            })
        },

        point_delete({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/point/delete', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err delete point', err.stack)
                        reject(err)
                    })
            })
        },

        order_create({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/create', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err create order', err.stack)
                        reject(err)
                    })
            })
        },

        order_update({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/update', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err update order', err.stack)
                        reject(err)
                    })
            })
        },

        order_delete({ commit }, orderId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/delete', { orderId })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order delete err', err.stack)
                        reject(err)
                    })
            })
        },

        order_assign({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/assign', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order assign err', err.stack)
                        reject(err)
                    })
            })
        },


        multi_order_revoke({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/multi-order/revoke', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('multi_order revoke err', err.stack)
                        reject(err)
                    })
            })
        },

        order_revoke({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/revoke', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order revoke err', err.stack)
                        reject(err)
                    })
            })
        },

        order_complete({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/complete', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order complete err', err.stack)
                        reject(err)
                    })
            })
        },

        order_send({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/order/send', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('order send err', err.stack)
                        reject(err)
                    })
            })
        },

        analytics_get({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/organization/analytics', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('analytic get err', err.stack)
                        reject(err)
                    })
            })
        },

        orders_date({ commit }, data) {
            return new Promise((resolve, reject) => {
                let service = !data.service?false:true
                if (service) return
                if (!data.guest_id) data.guest_id = 0
                if (!data.point_id) data.point_id = 0
                if (!data.point_ids) data.point_ids = 0
                if (!data.point_tid) data.point_tid = 0
                if (!data.mode) data.mode = 0
                if (!data.deliveryTime) data.deliveryTime = 0
                const params = {
                    operator_tid: this.state.operator_tid,
                    date1: data.date1,
                    date2: data.date2,
                    guest_id: data.guest_id,
                    point_id: data.point_id,
                    point_ids: data.point_ids,
                    point_tid: data.point_tid,
                    mode: data.mode,
                    deliveryTime: data.deliveryTime,
                }
                if(service){
                    if(!data.worker) data.courier = 0
                    params.worker=data.worker
                    if(!data.service_id) data.service_id=0
                    params.service_id=data.service_id
                }else {
                    if(!data.courier) data.courier = 0
                    params.courier=data.courier
                }
                let query = service?'/v1/service_orders_date':'/v1/orders_date'

                axios
                    .get(query, { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err orders_date', err.stack)
                        reject(err)
                    })
            })
        },

        customer_create({ commit }, orderId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/customer/create-from-order', { orderId })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('customer create err', err.stack)
                        reject(err)
                    })
            })
        },

        // ! all_orders_date
        all_orders_date({ commit }, data) {
            return new Promise((resolve, reject) => {
                if (!data.guest_id) data.guest_id = 0
                if (!data.point_id) data.point_id = 0
                if (!data.point_ids) data.point_ids = 0
                if (!data.point_tid) data.point_tid = 0
                if (!data.mode) data.mode = 0
                if (!data.deliveryTime) data.deliveryTime = 0

                const params = {
                    operator_tid: this.state.operator_tid,
                    date1: data.date1,
                    date2: data.date2,
                    guest_id: data.guest_id,
                    point_id: data.point_id,
                    point_ids: data.point_ids,
                    point_tid: data.point_tid,
                    mode: data.mode,
                    deliveryTime: data.deliveryTime,
                }

                if (!data.courier) data.courier = 0
                params.courier = data.courier

                params.courierId = data.courierId

                axios
                    .get('/v1/all_type_orders_date', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('err orders_date', err.stack)
                        reject(err)
                    })
            })
        },


        objects({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/objects')
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('objects err', err.stack)
                        reject(err)
                    })
            })
        },
        point_users({ commit }, data) {
            return new Promise((resolve, reject) => {
                let params
                if (data) {
                    params = {
                        point_name: data.point_name,
                    }
                } else {
                    params = {
                        operator_tid: this.state.operator_tid,
                    }
                }
                axios
                    .get('/v1/point_users', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('point_users err', err.stack)
                        reject(err)
                    })
            })
        },
        only_point_users({ commit }, data) {
            return new Promise((resolve, reject) => {
                let params
                if (data) {
                    params = {
                        point_name: data.point_name,
                    }
                } else {
                    params = {
                        operator_tid: this.state.operator_tid,
                    }
                }
                axios
                    .get('/v1/only_point_users', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('point_users err', err.stack)
                        reject(err)
                    })
            })
        },
        point_get({ commit }, point_id) {
            return new Promise((resolve, reject) => {
                const params = {
                    id: point_id,
                }
                axios
                    .get('/v1/point', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('point_get err', err.stack)
                        reject(err)
                    })
            })
        },
        points_get({ commit }) {
            return new Promise((resolve, reject) => {
                const params = {
                    operator_tid: this.state.operator_tid,
                }
                axios
                    .get('/v1/points', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('points_get err', err.stack)
                        reject(err)
                    })
            })
        },
        points_get_all({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/points_all')
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('points_get_all err', err.stack)
                        reject(err)
                    })
            })
        },
        guests_get({ commit }, data) {
            return new Promise((resolve, reject) => {
                if (!data.point_id) data.point_id = 0
                if (!data.dateCreate) data.dateCreate = 0
                if (!data.dateVisit) data.dateVisit = 0
                const params = {
                    operator_tid: this.state.operator_tid,
                    date1: data.date1,
                    date2: data.date2,
                    point_id: data.point_id,
                    dateCreate: data.dateCreate,
                    dateVisit: data.dateVisit,
                }
                axios
                    .get('/v1/guests', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('guests_get err', err.stack)
                        reject(err)
                    })
            })
        },
        guest_get({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    id: data.id,
                    phone: data.phone,
                }
                axios
                    .get('/v1/guest', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('guest_get err', err.stack)
                        reject(err)
                    })
            })
        },
        points_set({ commit }, points) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/points', points)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('points_set err', err.stack)
                        reject(err)
                    })
            })
        },

        point_address({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    city: this.state.settings.city,
                    point_name: data.point_name,
                    point_id: data.point_id,
                    address: data.address,
                    lat: data.lat,
                    lng: data.lng,
                }
                axios
                    .get('/v1/point_address', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('point_address err', err.stack)
                        reject(err)
                    })
            })
        },
        organization_price_distance({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/organization/price/distance', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('organization price distance err', err.stack)
                        reject(err)
                    })
            })
        },
        address_to_geofence({ commit }, address) {
            return new Promise((resolve, reject) => {
                const params = {
                    city: this.state.settings.city,
                    operator_tid: this.state.operator_tid,
                    address,
                }
                axios
                    .get('/v1/address_to_geofence', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('address_to_geofence err', err.stack)
                        reject(err)
                    })
            })
        },
        couriers_get({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    operator_tid: this.state.operator_tid,
                    online_only: data?.online_only ? 1 : 0,
                }
                axios
                    .get('/v1/couriers', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('couriers_get err', err.stack)
                        reject(err)
                    })
            })
        },
        workers_get_all({ commit }){
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/workers_all')
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('workers_get err', err.stack)
                        reject(err)
                    })
            })
        },
        workers_with_all_orders({ commit },data){
            return new Promise((resolve, reject) => {
                
                if(!data.service_id) data.service_id=0
                let params={
                    service_id:data.service_id
                }
                axios
                    .get('/v1/workers_with_all_orders',{params})
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('workers_with_all_orders err', err.stack)
                        reject(err)
                    })
            })
        },
        worker_delete_notify({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/worker_delete_notify', { data })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('worker_delete_notify err', err.stack)
                        reject(err)
                    })
            })
        },
        worker_orders_status({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/worker_orders_status', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('worker_orders_status err', err.stack)
                        reject(err)
                    })
            })
        },
        service_users({ commit }, data) {
            return new Promise((resolve, reject) => {
                let params
                if (data) {
                    params = {
                        service_name: data.service_name,
                    }
                } else {
                    params = {
                        operator_tid: this.state.operator_tid,
                    }
                }
                axios
                    .get('/v1/service_users', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('service_users err', err.stack)
                        reject(err)
                    })
            })
        },
        services_with_all_orders({commit}){
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/services_with_all_orders')
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('services_with_all_orders err', err.stack)
                        reject(err)
                    })
            })
        },
        services_get({commit}){
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/services')
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('services_get err', err.stack)
                        reject(err)
                    })
            })
        },
        services_get_all({commit}){
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/services_all')
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('services_all err', err.stack)
                        reject(err)
                    })
            })
        },
        service_delete({ commit }, id) {
            console.log('service_delete id', id)
            return new Promise((resolve, reject) => {
                axios
                    .delete('/v1/service', { data: { id } })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('service_delete err', err.stack)
                        reject(err)
                    })
            })
        },
        couriers_orders_today_get({ commit }, point_id) {
            return new Promise((resolve, reject) => {
                const params = {
                    operator_tid: this.state.operator_tid,
                    orders_today: 1,
                    point_id,
                }
                axios
                    .get('/v1/couriers', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('couriers_orders_today_get err', err.stack)
                        reject(err)
                    })
            })
        },
        organization_logistics({ commit }, pointId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/organization/logistics', { pointId })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('organization logistics err', err.stack)
                        reject(err)
                    })
            })
        },
        auth({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                commit('secu_init')

                axios
                    .post('/v1/login', {
                        name: user.name,
                        pass: user.password,
                    })
                    .then(resp => {
                        if (resp.data.success) {
                            axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.token
                            commit('auth_success', resp.data)
                        }
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('auth err', err.stack)
                        reject(err)
                    })
            })
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit('logout')
                this.state.geofences = {}
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        quick_answers_get({ commit }, id) {
            return new Promise((resolve, reject) => {
                const params = {
                    point_id: id,
                }
                axios
                    .get('/v1/quick_answers', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('quick_answers_get err', err.stack)
                        reject(err)
                    })
            })
        },
        quick_answer_create({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/quick_answer', {
                        name: data.name,
                        point_id: data.point_id,
                        food: data.food,
                        delivery: data.delivery,
                        isShowed: data.isShowed,
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('quick_answer_create err', err.stack)
                        reject(err)
                    })
            })
        },
        quick_answers_update({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/v1/quick_answers', {
                        id: data.id,
                        name: data.name,
                        point_id: data.point_id,
                        food: data.food,
                        delivery: data.delivery,
                        isShowed: data.isShowed,
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('quick_answers_update err', err.stack)
                        reject(err)
                    })
            })
        },
        quick_answers_delete({ commit }, id_answer) {
            return new Promise((resolve, reject) => {
                const params = {
                    id: id_answer,
                }
                axios
                    .delete('/v1/quick_answers', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('quick_answers_delete err', err.stack)
                        reject(err)
                    })
            })
        },
        point_fieldOfActivity_update({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/points_field_of_activity', payload)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('point_fieldOfActivity_update err', err.stack)
                        reject(err)
                    })
            })
        },
        point_average_check({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/point_average_check', payload)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('point_average_check err', err.stack)
                        reject(err)
                    })
            })
        },
        get_media_review({ commit }, id) {
            return new Promise((resolve, reject) => {
                const params = {
                    review_id: id,
                }
                axios
                    .get('/v1/review/media', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('get_media_review err', err.stack)
                        reject(err)
                    })
            })
        },
        get_media_file({ commit }, path_file) {
            return new Promise((resolve, reject) => {
                const params = {
                    path: path_file,
                }
                axios
                    .get('/v1/media_file', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('get_media_file err', err.stack)
                        reject(err)
                    })
            })
        },
        get_proceeds_analytic({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/get_proceeds_analytic', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        get_cancelled_orders_analytics({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v1/get_cancelled_orders_analytics', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        get_guests_analytic({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/get_guests_analytic', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        get_average_price_delivery({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/v1/get_average_price_delivery', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        reviews_date({ commit }, data) {
            return new Promise((resolve, reject) => {
                const params = {
                    operator_tid: this.state.operator_tid,
                    date1: data.date1,
                    date2: data.date2,
                    point_id: data.point_id,
                    courier_tid: data.courier_tid,
                }
                axios
                    .get('/v1/reviews_date', { params })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('reviews_date err', err.stack)
                        reject(err)
                    })
            })
        },
        review_parsers_get({ commit }, pointId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/review_parser/list', {
                        pointId,
                    })
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('review parser get err', err.stack)
                        reject(err)
                    })
            })
        },
        review_parsed_delete({ commit }, reviewParsedId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/review_parsed/delete', {
                        reviewParsedId,
                    })
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        reviews_parsed_get({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/review_parsed/list', {
                        dateStart: data.dateStart,
                        dateEnd: data.dateEnd,
                        pointId: data.pointId,
                    })
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        review_parsed_set({commit}, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/v2/review_parsed/update', data)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log('parsed review set err', err.stack)
                        reject(err)
                    })
            })
        },
        review_parser_set({commit}, data) {
            return new Promise((resolve, reject) => {
                if (data.id) {
                    axios
                        .post('/v2/review_parser/update', data)
                        .then(resp => {
                            resolve(resp)
                        })
                        .catch(err => {
                            console.log('review parser update err', err.stack)
                            reject(err)
                        })
                } else {
                    axios
                        .post('/v2/review_parser/create', {
                            ...data,
                            organizationId: this.state.user.organizationId
                        })
                        .then(resp => {
                            resolve(resp)
                        })
                        .catch(err => {
                            console.log('review parser create err', err.stack)
                            reject(err)
                        })
                }
            })
        },
    },
    getters: {
        isChrome(state, getters) {
            if (state.browser === BROWSERS.chrome) return true
            if (getters.getBrowser === BROWSERS.chrome) return true
            return false
        },
        getBrowser(state) {
            if (state.browser != '') return state.browser
            const userAgent = navigator.userAgent
            if (userAgent.match(/chrome|chromium|crios/i)) {
                state.browser = BROWSERS.chrome
            } else if (userAgent.match(/firefox|fxios/i)) {
                state.browser = BROWSERS.firefox
            } else if (userAgent.match(/safari/i)) {
                state.browser = BROWSERS.safari
            } else if (userAgent.match(/opr\//i)) {
                state.browser = BROWSERS.opera
            } else if (userAgent.match(/edg/i)) {
                state.browser = BROWSERS.edge
            } else {
                state.browser = BROWSERS.unknown
            }
            return state.browser
        },
        getOS(state) {
            if (state.operationSystem !== '') return state.operationSystem
            state.operationSystem = (function () {
                const userAgent = navigator.userAgent || navigator.vendor || window.opera
                if (/windows phone/i.test(userAgent)) {
                    return 'Windows Phone'
                }
                if (/android/i.test(userAgent)) {
                    return 'Android'
                }
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    return 'iOS'
                }
                return 'unknown'
            })()
            return state.operationSystem
        },
        isLoggedIn: state => {
            return state.token && state.token.length && !!state.secu9
        },
    },
})
